import { FC } from 'react'
import styles from 'components/features/pfm/PremiumBadge/PremiumBadge.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import NewSvg from 'icons/new.svg'

type PremiumBadgeProps = {

}

export const PremiumBadge: FC<PremiumBadgeProps> = (props) => {
  const {} = props

  return (
    <div className={ styles.premiumBadge } title='Premium'>
      <SvgIcon src={ NewSvg } />
    </div>
  )
}
